import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from "../authentication/authentication.service";
import { LoggingService } from "../logging/logging.service";
import { LazyLoadEvent } from "../../models/DataTables/lazyLoadEvent";
import { Advert, CreateAdvertModel, EditAdvertModel } from '../../models/inModels/Advert';

@Injectable()
export class AdvertService {
  private routeCategory = '/api/adverts';

  constructor(
    private http: HttpClient,
	private auth: AuthenticationService,
	private logging: LoggingService
  ) { }

  search(event: LazyLoadEvent): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/search`, JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

	get(id: number): Promise<Advert> {
		return this.http.get(`${this.auth.apiUrl}${this.routeCategory}/get/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response as Advert)
			.catch(error => this.logging.handleError(error));
	}

	create(user: CreateAdvertModel): Promise<Advert> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/create`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Advert)
			.catch(error => this.logging.handleError(error));
	}

	update(user: EditAdvertModel): Promise<Advert> {
		return this.http.post(`${this.auth.apiUrl}${this.routeCategory}/update`, JSON.stringify(user), { headers: this.auth.header })
			.toPromise()
			.then(response => response as Advert)
			.catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}/api/adverts/delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
	getDropdownList(event): Promise<any> {
		return this.http.post(`${this.auth.apiUrl}/api/adverts/dropdown`,JSON.stringify(event), { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}

}



// WEBPACK FOOTER //
// ./src/app/services/business/advert.service.ts